(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
function initDummyNavigation(){
 document.querySelectorAll('.dg12-menu').forEach(menu=>{
  if(menu.dataset.initialized)return;
  menu.dataset.initialized='true';
  menu.addEventListener('toggle',()=>{if(menu.open)menu.closest('nav').querySelectorAll('.dg12-menu').forEach(other=>{if(other!==menu)other.open=false})});
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();event.stopPropagation()}});
 });
}
initDummyNavigation();
document.addEventListener('shopify:section:load',initDummyNavigation);
document.addEventListener('click',event=>document.querySelectorAll('.dg12-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false}));

  } catch(e) { console.error(e); }
})();
})();
